import {
  VidstackPlayer,
  // VidstackPlayerLayout,
  PlyrLayout,
  // DefaultLayoutTranslations,
} from 'vidstack/global/player'
import {
  MediaRemoteControl,
} from 'vidstack'


const defaultUILabels = {
  // Most of the commented-out labels here are not in use in PlyrLayout,
  // and are included in VidstackPlayerLayout only.

  'Accessibility': gettext('Accessibility'),
  // 'AirPlay': gettext('AirPlay'),
  'All': gettext('All'),
  // 'Announcements': gettext('Announcements'),
  'Audio': gettext('Audio'),
  // 'Auto': gettext('Auto'),
  // 'Boost': gettext('Boost'),
  'Buffered': gettext('Buffered'),
  // 'Caption Styles': gettext('Caption styles'),
  'Captions': gettext('Captions'),
  // 'Captions look like this': gettext('Captions look like this'),
  // 'Chapters': gettext('Chapters'),
  // 'Closed-Captions Off': gettext('Captions off'),
  // 'Closed-Captions On': gettext('Captions on'),
  'Color': gettext('Colour'),
  'Connected': gettext('Connected'),
  'Connecting': gettext('Connecting'),
  'Continue': gettext('Continue'),
  'Current time': gettext('Current time'),
  'Default': gettext('Default'),
  // 'Depressed': gettext('Depressed'),
  'Disable captions': gettext('Disable captions'),
  'Disabled': gettext('Disabled'),
  'Disconnected': '',
  'Display Background': gettext('Display background'),
  'Download': gettext('Download'),
  // 'Drop Shadow': gettext('Drop shadow'),
  'Duration': gettext('Duration'),
  'Enable captions': gettext('Enable captions'),
  'Enabled': gettext('Enabled'),
  'End': gettext('End'),
  'Enter Fullscreen': gettext('Enter fullscreen'),
  // 'Enter PiP': gettext('Enter PiP'),
  'Exit Fullscreen': gettext('Exit fullscreen'),
  // 'Exit PiP': gettext('Exit PiP'),
  'Go back to previous menu': gettext('Go back to previous menu'),
  // 'Google Cast': gettext('Google Cast'),
  // 'Family': gettext('Family'),
  // 'Font': gettext('Font'),
  'Forward': gettext('Forward'),
  'Fullscreen': gettext('Fullscreen'),
  // 'Keyboard Animations': gettext('Keyboard animations'),
  // 'LIVE': gettext('LIVE'),
  'Loop': gettext('Loop'),
  'Mute': gettext('Mute'),
  // 'None': gettext('None'),
  'Normal': gettext('Normal'),
  'Off': gettext('Off'),
  // 'Opacity': gettext('Opacity'),
  // 'Outline': gettext('Outline'),
  'Pause': gettext('Pause'),
  // 'PiP': gettext('PiP'),
  'Play': gettext('Play'),
  'Playback': gettext('Playback'),
  'Played': gettext('Played'),
  'Quality': gettext('Quality'),
  // 'Raised': gettext('Raised'),
  'Replay': gettext('Replay'),
  'Reset': gettext('Reset'),
  'Restart': gettext('Restart'),
  'Rewind': gettext('Rewind'),
  'Seek': gettext('Seek'),
  // 'Seek Backward': gettext('Seek Backward'),
  // 'Seek Forward': gettext('Seek Forward'),
  'Settings': gettext('Settings'),
  // 'Shadow': gettext('Shadow'),
  // 'Size': gettext('Size'),
  // 'Skip To Live': gettext('Skip To Live'),
  'Speed': gettext('Speed'),
  'Start': gettext('Start'),
  // 'Text': gettext('Text'),
  // 'Text Background': gettext('Text background'),
  // 'Track': gettext('Track'),
  'Unmute': gettext('Unmute'),
  'Volume': gettext('Volume'),
}

const videoEls = document.querySelectorAll('video')

for (let videoEl of videoEls) {
  const sourceEls = videoEl.querySelectorAll('source')
  videoEl.setAttribute('data-matomo-title', videoEl.ariaLabel)

  const player = VidstackPlayer.create({
    target: videoEl,
    title: videoEl.ariaLabel,
    poster: videoEl.poster,
    layout: new PlyrLayout({
      translations: defaultUILabels,
      speed: [0.5, 1, 1.25, 1.5, 2],
    }),
  }).then((mediaPlayer) => {
    const remote = new MediaRemoteControl()
    remote.setTarget(mediaPlayer)

    const provider = mediaPlayer.querySelector('media-provider')
    provider.addEventListener('click', (event) => {
      // For some absurd reason, Vidstack doesn't implement autopause properly for the plyr layout
      remote.togglePaused()
    })

    // Removing these video events because matomo's media analytics plugin takes care of that.
    // https://developer.matomo.org/guides/media-analytics/options

    // mediaPlayer.addEventListener('playing', (event) => {
    //   // console.log('heard playing', event, `${videoEl.ariaLabel} ${videoEl.currentSrc}`)
    //   window._paq.push(['trackEvent', 'video-event', 'started playing', `${videoEl.ariaLabel} ${videoEl.currentSrc}`])
    // })
    //
    // mediaPlayer.addEventListener('ended', (event) => {
    //   // console.log('heard ended', event, `${videoEl.ariaLabel} ${videoEl.currentSrc}`)
    //   window._paq.push(['trackEvent', 'video-event', 'ended/completed playing', `${videoEl.ariaLabel} ${videoEl.currentSrc}`])
    // })
    //
    // mediaPlayer.addEventListener('error', (event) => {
    //   window._paq.push(['trackEvent', 'video-event', 'error', event])
    // })
  })


}
